'use client';

import { useEffect } from 'react';
import { RedirectContext } from '../redirect-component/redirectContext';
import { convertObjToSnakeCase } from '../../lib/utils';
import { logInfo } from '../logging';
import { Logger } from '../../../logging';

interface Props {
  redirectContext: RedirectContext;
}

const logger = Logger.logger();
const LOGGER_NAME = 'RedirectSuppressedLogger';

const RedirectSuppressedLoggerComponent: React.FC<Props> = ({
  redirectContext,
}) => {
  useEffect(() => {
    // Log to Datadog Browser Logs
    logInfo(
      logger,
      LOGGER_NAME,
      'RedirectSuppressed',
      'User viewing interstitial without automatic redirect',
      convertObjToSnakeCase(redirectContext)
    );
  }, [redirectContext]);

  return null;
};

export default RedirectSuppressedLoggerComponent;
